import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon';

export default function LegendSettings(props:any) {
  return (
    <SvgIcon viewBox='0 0 18 18' { ...props}>
     <path d="M6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.6326 0.0526785 17.7598 0.146447 17.8536C0.240215 17.9473 0.367392 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.367392 17.9473 0.240215 17.8536 0.146447C17.7598 0.0526785 17.6326 0 17.5 0L17.34 0.03L12 2.1L6 0ZM5 2.45V14.15L2 15.31V3.46L5 2.45ZM7 2.47L11 3.87V15.53L7 14.13V2.47ZM16 2.7V14.54L13 15.55V3.86L16 2.7ZM4.46 3.3L2.57 3.97V6.12L4.46 5.45V3.3ZM4.46 6.05L2.57 6.72V8.87L4.46 8.2V6.05ZM4.46 8.8L2.57 9.47V11.62L4.46 10.95V8.8ZM4.46 11.55L2.57 12.22V14.37L4.46 13.7V11.55Z" fill="currentColor"/>
    </SvgIcon>
  );
}